@for (menuItem of fnMenuItem.menuItemArray; track menuItem) {
  <li [ngClass]="{'nav-dropdown': menuItem.menuItemArray.length > 0 && menuItem.showDropIcon }" class="nav-item {{menuItem.customClass}}">
    <a (click)="menuClickHandler(menuItem)" [id]="menuItem.id" class="nav-link">

      @if (menuItem && menuItem.menuSmallIcon){
        <i [classList]="menuItem.menuSmallIcon"></i>
      } @else if (menuItem && menuItem.smallIcon) {
        <i [classList]="menuItem.smallIcon"></i>
      }
     
      <span innerHTML="{{ menuItem.name | fnTranslate }}"></span>
      @if (menuItem.menuItemArray && menuItem.menuItemArray.length > 0) {
        <i class="fa fa-angle-right float-right"></i>
      }
    </a>
    @if (!menuItem.isDisabled) {
      <ul fn-menu-item class="sidebar-menu-item nav-sub  {{ menuItem.id }}" [fnMenuItem]="menuItem"></ul>
    }
  </li>
}
